import { Component, Host, Input, Output } from '@angular/core';
import { BllAccordionWorkflowPanelComponent } from './accordion-workflow-panel.component';

import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BllExpandPanelHeaderComponent } from '../expand';
@Component({
  selector: 'bll-accordion-workflow-header',
  templateUrl: './accordion-workflow-header.component.html',
  // styleUrls: ['./accordion-header.scss'],
  host: {
    class: 'expand-header',
  },
})
export class BllAccordionWorkflowHeaderComponent extends BllExpandPanelHeaderComponent {
  _iconCenter: boolean;
  @Input()
  get iconCenter(): any {
    return this._iconCenter || this.accordion.iconCenter;
  }
  set iconCenter(value: any) {
    this._iconCenter = coerceBooleanProperty(value);
  }

  @Input()
  get iconClass(): string {
    return this._iconClass || this.accordion.iconClass;
  }
  set iconClass(value) {
    this._iconClass = value;
  }
  _iconClass: string;

  @Input()
  get iconArrow(): any {
    return this._iconArrow || this.accordion.iconArrow;
  }
  set iconArrow(value: any) {
    this._iconArrow = coerceBooleanProperty(value);
  }
  _iconArrow: boolean;

  @Input()
  get iconSize(): number {
    return this._iconSize || this.accordion.iconSize;
  }
  set iconSize(value: number) {
    this._iconSize = value;
  }
  _iconSize: number;

  get minusIcon(): string {
    return this.iconArrow ? 'dropdown' : 'minus';
  }

  get plusIcon(): string {
    return this.iconArrow ? 'dropdown' : 'plus';
  }

  get isOpen() {
    return this.accordion.isOpen;
  }

  get firstOpened() {
    return this.accordion._firstOpened;
  }

  get controlGroup() {
    return this.accordion.controlGroup;
  }

  constructor(@Host() public accordion: BllAccordionWorkflowPanelComponent) {
    super(accordion);
  }
}
